interface UploadedFile {
  name: string;
  url: string;
  expiresAt: number;
  signedId?: string;
}

function isUploadedFile(obj: unknown): obj is UploadedFile {
  if (!obj || typeof obj !== "object") return false;
  if (
    !Object.prototype.hasOwnProperty.call(obj, "name") ||
    !Object.prototype.hasOwnProperty.call(obj, "url") ||
    !Object.prototype.hasOwnProperty.call(obj, "expiresAt")
  )
    return false;
  const castObj = obj as Partial<UploadedFile>;
  return !!castObj.name && !!castObj.url && typeof castObj.expiresAt === "number";
}

export { type UploadedFile, isUploadedFile };
